// extracted by mini-css-extract-plugin
export var text = "_18-0";